<template>
    <div>
        <div class="form-group row">
            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.optionsValue') }} </label>
            <div class="col-sm-9">
                <div class="d-flex mb-3">
                    <div>
                        <button type="button" class="btn btn-outline-success" @click="handleAddOneOption">
                            <i class="fa fa-plus"></i>
                            <span class="ml-2">{{ $t('managerForm.settingPage.addOneItem') }}</span>
                        </button>
                        <button type="button" class="btn btn-outline-success ml-3" @click="handleAddMoreOption">
                            <i class="fa fa-plus"></i>
                            <span class="ml-2">{{ $t('managerForm.settingPage.addAllItem') }}</span>
                        </button>
                    </div>
                    <div class="ml-auto">
                        <button type="button" class="btn btn-outline-secondary" @click="handleDeleteAllOption">
                            <i class="fa fa-minus"></i>
                            <span class="ml-2">{{ $t('managerForm.settingPage.deleteAllItem') }}</span>
                        </button>
                    </div>
                </div>
                <div v-if="isAddMoreOption">
                    <h5 class="text-center font-weight-bold mb-4">{{ $t('managerForm.settingPage.addAllAtOnce') }}</h5>
                    <div class="mb-3">
                        <span>{{ $t('managerForm.settingPage.noteAddAllAtOnce') }}</span>
                    </div>
                    <div class="mb-4">
                        <textarea
                            v-model="formBlock.text_area_more_option"
                            rows="5"
                            class="form-control"
                            placeholder="選択肢1
選択肢2
選択肢3"
                        ></textarea>
                    </div>
                    <div class="text-center">
                        <button type="button" class="btn btn-outline-light btn-common-cancel" @click="handleCancelMoreOption">
                            <span>{{ $t('managerForm.settingPage.cancel') }}</span>
                        </button>
                        <button type="button" class="btn btn-success ml-3" @click="handleSaveMoreOption">
                            <span>{{ $t('managerForm.settingPage.add') }}</span>
                        </button>
                    </div>
                </div>
                <div v-else class="table-responsive">
                    <table class="table table-bordered table__option--block">
                        <thead>
                            <th v-for="(item, k) in HEADERS_TYPE" :key="k" :style="{ width: item.width + 'px', backgroundColor: '#ededed' }">
                                <div class="d-flex align-items-center">
                                    {{ item.label }} <span v-if="item.required" class="ml-1 text-danger">*</span>
                                </div>
                            </th>
                        </thead>
                        <Draggable
                            :list="formBlock.option_value"
                            tag="tbody"
                            ghost-class="ghost--option"
                            handle=".drag-handle"
                            @start="dragList = true"
                            @end="dragList = false"
                            @change="onHandleDrag"
                        >
                            <tr v-for="(itemOp, idx) in formBlock.option_value" :key="`tr-${idx}`">
                                <td class="text-center drag-handle" style="vertical-align: middle; cursor: auto">
                                    <div>{{ itemOp.unique_key }}</div>
                                </td>
                                <td>
                                    <div>
                                        <InputText
                                            :model.sync="itemOp.value"
                                            :config.sync="configFormInput.validateArrayOption[idx].configFieldValue"
                                            @blur="handleValidateField(configFormInput.validateArrayOption[idx].configFieldValue)"
                                        />
                                    </div>
                                </td>
                                <td v-if="activeTypeRemaining">
                                    <div>
                                        <InputText
                                            :model.sync="itemOp.number_of_receptions"
                                            :config.sync="configFormInput.validateArrayOption[idx].configFieldNumberOfReceptions"
                                            @blur="handleValidateField(configFormInput.validateArrayOption[idx].configFieldNumberOfReceptions)"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div class="text-left">
                                        <button type="button" class="btn btn-outline-secondary" @click="handleDeleteOneOption(idx)">
                                            <span>{{ $t('btn.delete') }}</span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </Draggable>
                    </table>
                    <span v-if="SUBMITED && formBlock.option_value.length === 0" class="d-block invalid-feedback"
                        >選択肢が一つも設定されていません。</span
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { TABLE_OPTION_BLOCK_COMMON, handleAddConfigOptions } from '../constants';
import { InputText } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { onHandleShowConfirm } from '@/utils/handlers';
import { ALL_BLOCK_TYPE } from '@/config/constants';

import Draggable from 'vuedraggable';
// import Swal from 'sweetalert2';

export default {
    name: 'ActionOptionSelectCommon',
    components: {
        Draggable,
        InputText
    },
    props: {
        formBlock: {
            type: Object,
            required: true,
            default: () => null
        },
        configFormInput: {
            type: Object,
            required: true,
            default: () => null
        },
        typeBlock: {
            type: String,
            required: true,
            default: () => ''
        },
        SUBMITED: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        activeTypeRemaining() {
            return this?.typeBlock == ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY;
        }
    },

    data() {
        return {
            TABLE_OPTION_BLOCK_COMMON: TABLE_OPTION_BLOCK_COMMON,
            HEADERS_TYPE: this.activeTypeRemaining ? TABLE_OPTION_BLOCK_COMMON.headersRemaining : TABLE_OPTION_BLOCK_COMMON.headers,
            isAddMoreOption: false,
            dragList: false
        };
    },

    methods: {
        handleValidateField(configField) {
            validateField(configField);
        },

        handleAddOneOption() {
            this.formBlock.option_value.push({
                option_index: this.formBlock.option_value.length,
                unique_key: this.onHandleMakeId(),
                value: '',
                number_of_receptions: ''
            });
            this.configFormInput.validateArrayOption = handleAddConfigOptions(this.configFormInput.validateArrayOption, this.formBlock.option_value);
            this.$emit('update:formBlock', this.formBlock);
        },

        onHandleMakeId() {
            const handleMakeId =
                this.formBlock.option_value.length <= 0
                    ? this.formBlock.option_value.length + 1
                    : Math.max(...this.formBlock.option_value.map((item) => (item?.unique_key ? Number(item.unique_key) : item.id))) + 1;
            return handleMakeId;
        },

        handleDeleteOneOption(index) {
            this.formBlock.option_value.splice(index, 1);
            this.configFormInput.validateArrayOption = handleAddConfigOptions(this.configFormInput.validateArrayOption, this.formBlock.option_value);
            this.$emit('update:formBlock', this.formBlock);
        },

        handleAddMoreOption() {
            this.isAddMoreOption = true;
        },

        handleCancelMoreOption() {
            this.formBlock.text_area_more_option = '';
            this.isAddMoreOption = false;
        },

        handleSaveMoreOption() {
            const resultArray = this.formBlock.text_area_more_option.split('\n').filter((line) => line.trim() !== '');
            for (let moreValue of resultArray) {
                if (this.formBlock.option_value.length === 1 && this.formBlock.option_value[0]?.value === '') {
                    this.formBlock.option_value = [];
                }
                this.formBlock.option_value.push({
                    option_index: this.formBlock.option_value.length,
                    unique_key: this.onHandleMakeId(),
                    value: moreValue,
                    number_of_receptions: ''
                });
                this.configFormInput.validateArrayOption = handleAddConfigOptions(
                    this.configFormInput.validateArrayOption,
                    this.formBlock.option_value
                );
            }
            this.isAddMoreOption = false;
            this.formBlock.text_area_more_option = '';
            this.$emit('update:formBlock', this.formBlock);
        },

        async handleDeleteAllOption() {
            if (this.formBlock.option_value.length > 0) {
                const confirm = await onHandleShowConfirm({
                    title: '項目をすべて削除します。よろしいですか？ ※公開済みの項目は削除されません。',
                    text: ''
                });
                if (confirm) {
                    this.formBlock.option_value.splice(0, this.formBlock.option_value.length);
                    this.$emit('update:formBlock', this.formBlock);
                }
            }
        },

        onHandleDrag() {
            this.formBlock.option_value = this.formBlock.option_value.map((opItem, idx) => {
                opItem.option_index = idx;
                return opItem;
            });
            this.configFormInput.validateArrayOption = handleAddConfigOptions(this.configFormInput.validateArrayOption, this.formBlock.option_value);
        }
    },

    watch: {
        activeTypeRemaining: {
            handler: function () {
                this.HEADERS_TYPE = this.activeTypeRemaining ? TABLE_OPTION_BLOCK_COMMON.headersRemaining : TABLE_OPTION_BLOCK_COMMON.headers;
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
.ghost--option {
    opacity: 0.5;
    background-color: #f8f9fa;
    border: dashed 1px #ccc;
}

.table__option--block {
    td {
        padding: 0.75rem;
    }
}
</style>
